import { useQuery } from '@tanstack/react-query';
import { LegalApi } from '../../../apis/LegalApi/LegalApi.ts';
import { ILegalRequirementsResponse } from '../Legal.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { AppMedError } from '../../../error/AppMedError.ts';

export function useGetLegalRequirements(enabled: boolean = true) {
    return useQuery<ILegalRequirementsResponse, AppMedError>({
        queryKey: [QueryKeys.legalRequirements],
        queryFn: async () => {
            return LegalApi.getRequirements();
        },
        enabled,
        retry: 2,
        staleTime: 0,
    });
}
